<template>
    <ContentComp v-if="model != null">
        <FormLayout :label-width="250">
            <FormLayoutRow>
                <FormLayoutLabel
                    text="stationrole.acceptchipforrelaylegnumber"
                    tooltip="stationrole.acceptchipforrelaylegnumbertooltip"
                ></FormLayoutLabel>
                <div class="w-25">
                    <InputNullableInt
                        v-model="model.AcceptChipForRelayLegnumber"
                        icon=""
                    />
                </div>
            </FormLayoutRow>

            <FormLayoutRow>
                <FormLayoutLabel
                    text="stationrole.relaylegnumber"
                    tooltip="stationrole.relaylegnumbertooltip"
                ></FormLayoutLabel>
                <div class="w-25">
                    <InputNullableInt
                        v-model="model.RelayLegnumber"
                        icon=""
                    />
                </div>
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { InputNullableInt } from '@/components';

import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import ContentComp from '@/components/layout/ContentComp.vue';
import { StationRole } from '@/objects/generated';

const model = defineModel<StationRole | null>({ required: true });
</script>
